import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { ListOption } from '../modules/tcm-core.module';
import { WorkQueueListOptionRequest } from '../models/work-queues/work-queue-list-option-request';

@Injectable({
  providedIn: 'root'
})
export class WorkQueueDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  getWorkQueueOptionsForUserAsync(query: string, userId: number, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: WorkQueueListOptionRequest = {
      searchString: query,
      userId: userId
    };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('WorkQueues/Options', request, cancellationToken);
  }
}
